<template>
    <div class="btn" @click="openApp" v-if="showFloatButton">
        <img :src="icon" alt="icon">
        <span class="close" @click="closeBtn">
            <img :src="icon_close" alt="close">
        </span>
    </div>
</template>
<script>
import icon from "../../less/images/callapp.png"
import icon_close from '../../less/images/icon_close@2x.png'
import CallAppComp from './CallApp'
import MptcfeUtils from 'mptcfe-utils'

const _callUniqueId = MptcfeUtils.Utils.getPvId()
export default {
    name: 'CallSohunews',
    props: ['newsid'],
    data(){
        return {
            icon,
            icon_close,
            closeTime: localStorage.getItem('closeTime'),
            isFirstVisit: true,
        }
    },
    computed: {
        showFloatButton() {
            return this.isFirstVisit && (Date.now() - this.closeTime > 72 * 60 * 60 * 1000)
        },
    },
    methods: {
        openApp() {
            const jumpURL = 'https://3g.k.sohu.com/h5apps/20230719_refresh/html/simplify.html?page_h=9147&channelId=3228'
            const deeplink = `sohunews://pr/news://newsId=${this.newsid}&forwardurl=audioplay%3A%2F%2Fvolume%3D30%26tipsMsg%3D%26playStatus%3D0%26playLoc%3D&startfrom=4309deeplink${_callUniqueId}&binfo=${CallAppComp.getExplorerInfo()}`
            // const downloadURL = "https://3g.k.sohu.com/api/function/getChannelPackageUrl.go?channelId=3789&rd=1"
            const clickAcode = 10477
            const downloadAcode = 10486
            CallAppComp.openApp(clickAcode, downloadAcode, deeplink, jumpURL)
        },
        closeBtn(event) {
            event.stopPropagation()
            this.isFirstVisit = false
            localStorage.setItem('closeTime', Date.now())
            MptcfeUtils.Utils.sendSpmAction(10566)
        }
    },
}
</script>

<style lang="less" scoped>
    .btn {
        width: 300px;/*px*/
        height: 80px;/*px*/
        position: relative;
        .close {
            width: 36px; /*px*/
            height: 36px; /*px*/
            position: absolute;
            top: -8px; /*px*/
            right: -8px; /*px*/
        }
    }
</style>